{{ commentSymbol }}
{{ commentSymbol }} Copyright (c) 2019-present UVMGen LLC (uvmgen.com)
{{ commentSymbol }}
{{ commentSymbol }} This is a READ ONLY file generated by UVMGen{{#if isDesktop}}, LLC using the UVMGen on-premise license{{/if}}. It may be overwritten.
{{ commentSymbol }}
{{ commentSymbol }} {{#if isWeb}}MIT License{{else}}Commercial License{{/if}}
{{ commentSymbol }}
{{#if isDesktop}}
{{ commentSymbol }} You are granted a limited license to use and modify this code solely for internal
{{ commentSymbol }} use within your organization. You are not authorized to distribute or share this code
{{ commentSymbol }} with third parties outside of your organization unless these third parties are bound
{{ commentSymbol }} by a valid Non-Disclosure Agreement (NDA) that covers the use of this code.
{{ commentSymbol }}
{{ commentSymbol }} For licensing inquiries or more information, please contact feedback@uvmgen.com.
{{ commentSymbol }}
{{/if}}
{{ commentSymbol }} The above copyright notice and this permission notice shall be included in all
{{ commentSymbol }} copies or substantial portions of the Software.

